module.exports = __webpack_public_path__ + "static/media/icon-event-call.2b23e08a.svg";